import type { AgentParams, CreateAgentRequest } from '../agent.api.types';
import type { Agent } from '../agent.types';
import {
  transformCreateAgentRequest,
  transformCreateAgentResponse,
  transformListAgentsResponse,
  transformUpdateAgentRequest,
} from '../transformers';
import { type Builder } from './types';

export const agentsEndpoints = (builder: Builder) => ({
  listAgents: builder.query<Agent[], string>({
    query: (projectId) => {
      return {
        url: `agents`,
        headers: {
          'Project-Id': projectId,
        },
      };
    },
    transformResponse: transformListAgentsResponse,
    providesTags: ['Agents'],
  }),
  createAgent: builder.mutation<Agent, CreateAgentRequest>({
    query: (request) => ({
      url: 'agents',
      body: transformCreateAgentRequest(request),
      method: 'POST',
      headers: {
        'Project-Id': request.projectID,
      },
    }),
    transformResponse: transformCreateAgentResponse,
    invalidatesTags: ['Agents'],
  }),
  getAgent: builder.query<Agent, AgentParams>({
    query: ({ agentId, projectId }) => {
      return {
        url: `agents/${agentId}`,
        headers: {
          'Project-Id': projectId,
        },
      };
    },
    transformResponse: transformCreateAgentResponse,
    providesTags: ['Agents'],
  }),
  updateAgent: builder.mutation<Agent, { agentId: string; projectId: string; request: Partial<Agent> }>({
    query: ({ agentId, request, projectId }) => ({
      url: `agents/${agentId}`,
      method: 'PATCH',
      headers: {
        'Project-Id': projectId,
      },
      body: transformUpdateAgentRequest(request),
    }),
    transformResponse: transformCreateAgentResponse,
    invalidatesTags: ['Agents'],
  }),
  deleteAgent: builder.mutation<void, AgentParams>({
    query: ({ agentId, projectId }) => {
      return {
        url: `agents/${agentId}`,
        method: 'DELETE',
        headers: {
          'Project-Id': projectId,
        },
      };
    },
    invalidatesTags: ['Agents'],
  }),
});
